import styled from '@emotion/styled'
import { Image as RemServImage } from 'RemServ/images'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Jumbotron } from 'react-bootstrap'
import { ITheme } from 'application/utils/type'

interface IInputProps {
  isHomePage: boolean
  isLeftAlign: boolean
  theme: ITheme
}

export const BannerContentDiv = styled.div<IInputProps>`
  label: BannerContentDiv;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: ${(props) => (props.isLeftAlign ? 'left' : 'center')};
  font-size: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.isHomePage
        ? '56px'
        : '28px'
      : '48px'};
  color: ${(props) => props.theme.colors.white};
  font-weight: ${(props) => (props.theme.brand == 'Maxxia' ? 700 : 600)};
  width: 100%;
`

export const ParentDiv = styled(Jumbotron)<IInputProps>`
  label: ParentDiv;
  z-index: 1;
  position: relative;
  padding: ${(props) =>
    props.theme.brand == 'Maxxia' ? '0px' : '37px 37px 55px 37px'};
  min-height: 468px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: auto;
  background-color: ${(props) => props.theme.backgrounds.backGround2};
  @media (max-width: 980px) {
    padding: ${(props) =>
      props.theme.brand == 'Maxxia' ? '0px' : '37px 37px 58px 37px'};
  }
  @media (max-width: 750px) {
    padding: ${(props) =>
      props.theme.brand == 'Maxxia' ? '0px' : '37px 37px 32px 37px'};
  }
`

export const ChildPropsDiv = styled.div`
  label: ChildPropsDiv;
  z-index: 99;
  width: 1046px;
  font-weight: 800 !important;
  padding-left: 37px;
`

export const RemServBannerImage = styled(RemServImage)`
  label: RemServBannerImage;
  position: absolute;
  top: -30px;
  width: 100%;
  z-index: 1;
  height: 500px;
  @media (max-width: 600px) {
    height: auto;
    width: auto;
  }
`
export const MaxxiaBannerImage = styled(MaxxiaImage)`
  label: MaxxiaBannerImage;
  position: absolute;
  top: -28px;
  width: 100%;
  z-index: 1;
`
